import React from 'react';
import Link from 'next/link';
import { withTheme } from '@emotion/react';
import { TestId } from '@components/test-ids';
import { Theme } from '@theme/base';
import { useI18NextContext } from '@components/hooks';
import { Page } from '@model/common/pages';
import { PageData } from '@model/content';
import { OfferLink } from '@components/common/next-link/offer-link';
import { NavContainer, NavHeading, NavItem, LinksListContainer } from './styles';

/* ***************** *
 *       Types       *
 * ***************** */
export interface OffersNavContentProps {
  theme?: Theme;
  testId?: string;
  offerPages: Array<PageData>;
  onToggleDesktopNav?: () => void;
}

/* *********************************** *
 *    OffersNavContentComponent    *
 * *********************************** */

export const OffersNavContentComponent = (props: OffersNavContentProps) => {
  const { onToggleDesktopNav, offerPages } = props;

  if (!offerPages) {
    return null;
  }

  const t: any = useI18NextContext();
  const renderLinks = () =>
    offerPages.map((offerTypeEntry: PageData) => (
      <NavItem onClick={onToggleDesktopNav} key={offerTypeEntry.path}>
        <OfferLink path={'/'.concat(offerTypeEntry.path)}>{offerTypeEntry.name}</OfferLink>
      </NavItem>
    ));
  return (
    <NavContainer data-testid={props.testId || TestId.offersNavContent.main}>
      <NavHeading>
        {t('common__label--special-offers')}{' '}
        <span>
          (
          <Link prefetch={false} href={Page.OFFERS}>
            {t('nav__label--view-all')}
          </Link>
          )
        </span>
      </NavHeading>
      <LinksListContainer displayInColumns={offerPages.length > 4}>{renderLinks()}</LinksListContainer>
    </NavContainer>
  );
};

export const OffersNavContent = withTheme(OffersNavContentComponent);
